export default "__VITE_ASSET__DJuN8cFE__"